import React, { useState, useEffect } from 'react';
import { message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAppStore } from '../store/appStore';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [requestCode, setRequestCode] = useState(null);
  const navigate = useNavigate();
  const setToken = useAppStore((state) => state.setToken);

  const startTelegramLogin = async () => {
    try {
      setLoading(true);
      const res = await api.post('/auth/telegram/request');
      const { url, code } = res.data;
      
      if (!url || !code) {
        message.error('Не удалось получить ссылку входа');
        return;
      }
      
      setRequestCode(code);
      setWaiting(true);
      
      // Open Telegram in new tab
      window.open(url, '_blank');
      
    } catch (err) {
      message.error(err?.response?.data?.error || 'Ошибка запуска авторизации');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!waiting || !requestCode) return;

    const interval = setInterval(async () => {
      try {
        const res = await api.get(`/auth/telegram/check/${requestCode}`);
        if (res.data.status === 'authorized' && res.data.token) {
          clearInterval(interval);
          setToken(res.data.token);
          message.success('Успешный вход!');
          navigate('/dashboard', { replace: true });
        } else if (res.data.status === 'expired' || res.data.status === 'used') {
           clearInterval(interval);
           setWaiting(false);
           setLoading(false);
           message.error('Ссылка устарела, попробуйте снова');
        }
      } catch (err) {
        console.error('Polling error', err);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [waiting, requestCode, navigate, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-surface rounded-2xl border border-white/5 p-8 text-center">
        <h1 className="text-2xl font-bold text-white mb-2">Вход</h1>
        <p className="text-slate-400 mb-8">Авторизация через Telegram</p>

        {!waiting ? (
          <>
            <button
              onClick={startTelegramLogin}
              disabled={loading}
              className="w-full btn-primary disabled:opacity-50"
            >
              {loading ? 'Подготовка...' : 'Войти через Telegram'}
            </button>
            <div className="mt-8 text-xs text-slate-500 leading-relaxed">
              Нажмите кнопку, перейдите в бота и нажмите «Запустить» (Start).
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center gap-6 py-4">
            <Spin size="large" />
            <div className="text-slate-300">
              <p className="font-medium mb-2">Ожидаем подтверждения в Telegram...</p>
              <p className="text-sm text-slate-500">
                Перейдите в открывшееся окно Telegram и нажмите <b>Start</b>
              </p>
            </div>
            <button 
              onClick={() => { setWaiting(false); setLoading(false); }}
              className="text-sm text-slate-500 hover:text-white transition-colors"
            >
              Отмена
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
